import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=badd116c&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('badd116c')) {
      api.createRecord('badd116c', component.options)
    } else {
      api.reload('badd116c', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=badd116c&", function () {
      api.rerender('badd116c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2qyUXokG8BiYN/JS/comp/IncreaseNumber.vue"
export default component.exports